import { render, staticRenderFns } from "./PerformanceReviewTemplate.vue?vue&type=template&id=5b9aa80e&"
import script from "./PerformanceReviewTemplate.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports